import { Component, ElementRef, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FarmMapService } from '../../services/farm-map.service';
import { LoadingService } from '../../../../../core/services/loading.service';
import { ScoutingResponse } from '../../models/scouting.model';
import { ModalService } from 'src/app/core/services/modal.service';
import { IListModalModel } from 'src/app/core/models/interfaces/modal-components-models';
import { TranslateService } from '@ngx-translate/core';
import { AddScoutingNoteModalComponent } from '../add-scouting-note-modal/add-scouting-note-modal.component';
import { FarmMapResponse } from '../../models/farm-map.model';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { PopoverTemplateComponent } from 'src/app/core/helper/class/popover-template.component';
import { Gesture, PopoverController } from '@ionic/angular';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { MapService } from 'src/app/core/services/map.service';
@Component({
  selector: 'app-scouting-note-info',
  templateUrl: './scouting-note-info.component.html',
  styleUrls: ['./scouting-note-info.component.scss'],
})
export class ScoutingNoteInfoComponent implements OnInit {
  @ViewChild('pullupHandler') pullupHandler: ElementRef
  @ViewChild('mainContainer') mainContainer: ElementRef
  @Input() currentMap
  @Input() refresh: number
  @Input() id: number;
  @Input() scoutingId: number;
  @Input() farm: FarmMapResponse;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>()
  @Output() onBackPressed: EventEmitter<any> = new EventEmitter<any>()
  @Output() onError: EventEmitter<any> = new EventEmitter<any>()
  @Output() refreshFlagMarkers: EventEmitter<boolean> = new EventEmitter<boolean>()

  isFullscreen: boolean = false
  mainContainerLastHeight
  styleClass: "full" | "mid" | "min" = "mid"
  gesture: Gesture
  scoutingData: ScoutingResponse;
  tagList: Array<any> = [];
  tagValueList: any;
  isFiliz: boolean = false;
  constructor(private farmMapService: FarmMapService,
    private loadingService: LoadingService,
    private modalService: ModalService,
    private translate: TranslateService,
    private alertService: ClientAlertService,
    private popoverController: PopoverController,
    private constantService: DoktarConstantsService,
    private storageService: StorageService,
    private mapService: MapService) { }

  ngOnInit() {
    this.getTagList();
    this.getInformation();
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      this.isFiliz = e.Data;
    })
  }

  ionViewDidEnter() {

  }

  getInformation() {
    this.loadingService.showLoading();
    this.farmMapService.getScoutingInformation(this.scoutingId).subscribe(res => {
      if (res.IsSuccess) {
        this.scoutingData = res.Data;
        if (this.scoutingData)
          this.scoutingData.GeoJsonObj = JSON.parse(this.scoutingData.GeoJson);
      }
      this.loadingService.hideLoading();
    }, err => {
      this.loadingService.hideLoading();
    });
  }

  getCategory(id: number) {
    if (this.tagList.length > 0) {
      return this.tagList.filter(e => e?.ConstantId == id)[0]?.ConstantValue;
    } else {
      return ""
    }
  }

  getTagList() {
    this.constantService.RequestTagList().subscribe(response => {
      this.tagList = response;
    });
  }

  openOptions(ev) {
    let that = this
    let options: Array<IListModalModel & { handler }> = [{
      id: 1,
      value: this.translate.instant("tools.notes_opts_edit"),
      handler: (ev) => {
        this.modalService.presentModal({
          component: AddScoutingNoteModalComponent,
          componentProps: {
            flagCoordinates: { lat: this.scoutingData.GeoJsonObj.geometry.coordinates[1], lng: this.scoutingData.GeoJsonObj.geometry.coordinates[0] },
            currentFarm: this.farm,
            oldFlagNote: this.scoutingData
          },
          options: ModalService.fullPageOptions
        }).then(response => {
          response.modalObj.onDidDismiss().then(dismiss => {
            if (dismiss && dismiss.role === "saved") {
              that.modalService.dismissByModalId(this.id, "saved");
              this.farmMapService.getFarmList().subscribe(e => {
                if (e) {
                  this.getInformation();
                  this.refreshFlagMarkers.emit(true);
                  that.goBackTools("edit",this.scoutingData.FlagId)
                }
              });
            }
          })
        })
      }
    },
    {
      id: 1,
      value: this.translate.instant("tools.notes_opts_delete"),
      handler: (ev) => {
        this.alertService.confirmAlert({
          buttons: [{
            callback: (ev) => {
              //TODO delete
              let payload = {
                Id: this.scoutingData.FlagId
              }
              this.loadingService.showLoading();
              that.farmMapService.removeNote(payload).subscribe(response => {
                if (response.IsSuccess) {
                  that.goBackTools("delete",this.scoutingData.FlagId);
                  this.loadingService.hideLoading();
                }
              })
            },
            color: "primary",
            fill: "solid",
            text: this.translate.instant("tools.notes_delete_current_note")
          },
          {
            callback: () => { },
            color: "dark",
            fill: "clear",
            text: this.translate.instant("tools.notes_dont_want_to_delete")
          }
          ],
          image: "../../../../../assets/images/delete_icon_v1.svg",
          title: this.translate.instant("tools.notes_delete_note_title")
        })
      }
    }
    ]
    this.popoverController.create({
      component: PopoverTemplateComponent,
      componentProps: { itemList: options },
      event: ev
    }).then(response => {
      response.present();
      response.onDidDismiss().then(dismiss => {
        if (dismiss.role == 'clicked') {
          dismiss.data.handler()
        }
      })
    })
  }


  goBackTools(action?, value?) {
    this.mapService.clearMarkersLayer({ map: this.currentMap, callback: this.flagCallback, tempFarmAttId: this.farm.TempFarmAttId })
    this.onBackPressed.emit({action, value})
  }

  flagCallback = (ev) => {
    var features = this.currentMap.queryRenderedFeatures(ev.point, { layers: [ev.features[0].layer.id] });
    if (Array.isArray(features) && features.length > 0) {
      let flagId = features[0].properties.id;
      this.scoutingData = this.farm.ScoutingIdList.find(t => t.Id ==flagId)[0];
    }
  }
}
